import { UserRole } from "./User";

export enum NAVIGATION_NAME {
  HOME = "Inicio",
  DASHBOARD = "Dashboard",
  DEVICES = "Dispositivos",
  SESSION = "Sesiones",
  SCORES = "Puntajes",
  MATCHES = "Partidas",
  USERS = "Usuarios",
  CONFIGS = "Configuraciones",
  LINKS = "Vinculaciones",
  DOCUMENTATION = "Documentación",
}

export type NavigationCluster = Record<UserRole, SidebarItem[]>;

export interface SidebarItem {
  name: NAVIGATION_NAME;
  href: string;
  icon: any;
}
